<template>
    <v-content v-if="! isLogged">
        <v-container fluid grid-list>
            <v-layout row align-center justify-center mt-4>
                <v-flex xs3 sm3 md3>
                    <img :src="BASE_ASSETS + logo" style="height: 100%">
                </v-flex>
            </v-layout>
            <v-layout row align-center justify-center mt-3 v-if="estado">
                <v-flex xs12 sm12 md12>
                    <p class="display-1 text-xs-center">Sign in to start your session</p>
                </v-flex>
            </v-layout>

            <v-layout row align-center justify-center mt-3 v-if="estado">
                <v-flex xs12 sm6 md5>
                    <form @submit.prevent="login">
                        <v-flex xs12>
                            <v-text-field
                                    v-validate="'required|email'"
                                    v-model="login_data.email"
                                    :error-messages="errors.collect('login_data.email')"
                                    label="E-mail"
                                    data-vv-name="login_data.email"
                                    browser-autocomplete="off"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    v-validate="'required'"
                                    type="password"
                                    v-model="login_data.password"
                                    :error-messages="errors.collect('login_data.password')"
                                    label="Password"
                                    data-vv-name="login_data.password"
                                    browser-autocomplete="off"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="show_verification_code">
                          <v-text-field
                                    v-validate="'required'"
                                    type="text"
                                    v-model="login_data.verification_code"
                                    :error-messages="errors.collect('login_data.password')"
                                    label="6-digits verification code"
                                    data-vv-name="login_data.verification_code"
                                    browser-autocomplete="off"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <a href="" @click.prevent="resetPassword">I forgot my password</a>
                            <v-btn large color="secondary" class="text--primary" type="submit" :loading="loading">Sign in</v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert
                                    v-if="message_error_login"
                                    :value="true"
                                    color="error"
                                    icon="warning"
                                    outline
                            >
                                {{ message_error_login }}
                            </v-alert>
                        </v-flex>
                    </form>
                </v-flex>
            </v-layout>

            <v-layout row align-center justify-center mt-3 v-if="! estado">
                <v-flex xs12 sm6 md5>
                    <v-flex xs12>
                        <h2>Importar usuarios:</h2>
                    </v-flex>
                    <v-flex xs12 class="mt-1">
                        <vue-dropzone ref="myVueDropzone" id="dropzone4" :options="dropzoneOptions" v-on:vdropzone-success="$router.push({ name: 'import-clients' })"></vue-dropzone>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { API_BASE, BASE_ASSETS } from  '../../config';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        data : function() {
            return {
                login_data : {
                    email : '',
                    password : '',
                    verification_code : ''
                },
                error_login : false,
                message_error_login : null,
                show_verification_code : false,
                dictionary: {
                    custom: {
                        "login_data.email": {
                            required: 'The email field is required.',
                            email: () => 'The email field must be a valid email'
                        },
                        "login_data.password": {
                            required: 'The password field is required.'
                        }
                    }
                },
                loading: false,
                estado: true,
                dropzoneOptions: {
                    url: API_BASE + 'import/users',
                    thumbnailWidth: 150,
                    maxFilesize: 50000,
                    headers: { 'Authorization' : localStorage.getItem('token'),
                        'Autrollization' : localStorage.getItem('token'),
                        'Authorization-temp' : localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                },
                BASE_ASSETS: BASE_ASSETS
            }
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        created () {
            this.getEstado();
            this.setSectionTitle();
        },
        methods : {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: ''
                });
            },
            login : function() {

                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.loading = true;
                        this.error_login = false;
                        this.message_error_login = '';

                        //dispatch the login and catch the response with the promise declared in vuex Authmodule
                        this.$store.dispatch('login', {
                            login_data : this.login_data
                        }).then((res) => {
                            this.loading = false;
                            this.login_data = {
                                email : '',
                                password : ''
                            };

                            if (res.data.rol == 'AMC') {
                               this.$router.push({ name: 'ftn.sample-orders.list' });
                            }

                            if (res.data.rol == 'Admin') {
                                this.$router.push({ name: 'admin.home' });
                            }

                            if (res.data.rol == 'Agent') {
                                this.$router.push({ name: 'agent.home' });
                            }
                        }).catch((error) => {
                            //if incorrect we show a message
                            this.error_login = true;
                            this.message_error_login = error.data.message;
                            this.loading = false;

                            if(error.data.message_status == 'verification_code'){
                              this.show_verification_code = true;
                            }
                        });
                    }
                });

            },
            resetPassword() {
                this.$router.push({ name: 'send-reset-password' });
            },
            getEstado() {
                this.$store.dispatch('getEstado', {}).then((res) => {
                    this.estado = res.data.estado;
                }).catch((error) => {

                });
            }
        },
        computed : {
            isLogged : function(){
                return this.$store.getters.isLogged;
            },
            logo () {
                return require('@/assets/logo.png')
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/LoginComponent.vue